module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (233).139eb26a.jpg";